
import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../../Context/ThemeContext';
import { AuthApi } from '../../Api/BaseApi';
import './index.css';

const NotFound = () => {
  const { isDarkMode } = useTheme();
  const isAuthenticated = AuthApi.isAuthenticated();

  return (
    <div className={`notfound-container ${isDarkMode ? 'dark-mode' : ''}`}>
      <div className="notfound-content">
        <h1 className="notfound-title">404</h1>
        <p className="notfound-subtitle">
          <span className="notfound-oops-text">Oops!</span> Page not found.
        </p>
        <p className="notfound-text">
          The page you're looking for doesn't exist or has been moved.
        </p>
        {isAuthenticated ? (
          <Link to="/" className="notfound-button">
            Go Home
          </Link>
        ) : (
          <Link to="/login" className="notfound-button">
            Go Back
          </Link>
        )}
      </div>
    </div>
  );
};

export default NotFound;
